export enum TrafficTicketPayableStatusEnum {
  Sent = 1,
  NotSent = 2
}